import { AppShell } from '@mantine/core';
import { Outlet } from 'react-router-dom';

import FooterNav from '@components/FooterNav';
import HeaderNav from '@components/HeaderNav';
import Navigation from '@components/Navigation';
import { useSidebar } from '@/context/SidebarContext';
import { SidebarState } from '@/types';
import { RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';

export function MainLayout() {
  const { sidebarState, setSidebarState } = useSidebar();

  const handleSidebarClose = () => {
    setSidebarState('hidden');
  };

  const handleSidebarStateChange = (state: SidebarState) => {
    setSidebarState(state);
  };

  return (
    <>
      <SignedIn>
        <AppShell
          header={{ height: 60 }}
          navbar={{
            width: sidebarState === 'full' ? 300 : sidebarState === 'mini' ? 80 : 0,
            breakpoint: 'sm',
            collapsed: { mobile: sidebarState === 'hidden', desktop: false },
          }}
          layout="alt"
          padding="md"
          styles={{
            main: {
              width: '100%',
              maxWidth: '100%',
            },
          }}
        >
          <AppShell.Header>
            <HeaderNav sidebarState={sidebarState} onSidebarStateChange={handleSidebarStateChange} />
          </AppShell.Header>

          <AppShell.Navbar>
            <Navigation sidebarState={sidebarState} onClose={handleSidebarClose} />
          </AppShell.Navbar>

          <AppShell.Main>
            <Outlet />
          </AppShell.Main>

          <AppShell.Footer>
            <FooterNav />
          </AppShell.Footer>
        </AppShell>
      </SignedIn><SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}